import { Injectable } from '@angular/core';
import { IIDolClienteStore } from './iidOlCliente.store';
import { IID_OL_CLIENTE } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolClienteQuery } from './iidOlCliente.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.CLIENTE)
export class IIDolClienteService extends CrudService<IID_OL_CLIENTE, IIDolClienteStore, IIDolClienteQuery> {
  constructor(
    protected store: IIDolClienteStore,
    public query: IIDolClienteQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_OL_CLIENTE,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
